/**
 * The API answers with the canonical flat envelope {error, message}, so a
 * failed mutation already carries a message worth showing (which field, which
 * limit, which conflict). Fall back to a generic line only when it does not.
 */
export function messageOf(err: unknown, fallback: string): string {
  const res = (err as { response?: { data?: { message?: string } } })?.response
  return res?.data?.message ?? fallback
}
